// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"25":"13c28bdf","44":"78b949f3","847":"4274f16d"}[chunkId] + ".js";
};